/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Treadmill/millArmrest.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation1.play();
    actions.Animation1.repetitions = 1;
    actions.Animation1.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="armrest" geometry={nodes.armrest.geometry} material={materials.黑泡棉} />
      </group>
    </group>
  )
}

useGLTF.preload('/Treadmill/millArmrest.glb')
